module.exports = __webpack_public_path__ + "static/media/Arrow-up-green.815b142d.svg";